import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const FaceTiredIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15ZM8.46154 13C9.31121 13 10 12.3112 10 11.4615V11C10 9.89543 9.10457 9 8 9C6.89543 9 6 9.89543 6 11V11.4615C6 12.3112 6.68879 13 7.53846 13H8.46154ZM6.83541 5.82916C7.20589 6.0144 7.35606 6.46491 7.17082 6.83539C6.86395 7.44913 6.35121 8.01893 5.64354 8.22112C4.88217 8.43866 4.11192 8.17256 3.46967 7.53031C3.17678 7.23742 3.17678 6.76254 3.46967 6.46965C3.76256 6.17676 4.23744 6.17676 4.53033 6.46965C4.88808 6.8274 5.11783 6.8113 5.23146 6.77884C5.39879 6.73103 5.63605 6.55083 5.82918 6.16457C6.01442 5.79409 6.46493 5.64392 6.83541 5.82916ZM9.32918 6.83539C9.14394 6.46491 9.29411 6.0144 9.66459 5.82916C10.0351 5.64392 10.4856 5.79409 10.6708 6.16457C10.864 6.55083 11.1012 6.73103 11.2685 6.77884C11.3822 6.8113 11.6119 6.8274 11.9697 6.46965C12.2626 6.17676 12.7374 6.17676 13.0303 6.46965C13.3232 6.76254 13.3232 7.23742 13.0303 7.53031C12.3881 8.17256 11.6178 8.43866 10.8565 8.22112C10.1488 8.01893 9.63605 7.44913 9.32918 6.83539Z"
		/>
	</svg>
))
